import React, { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import { Landing } from "./pages/Landing";
import { useMetaPixel } from "./hooks/useMetaPixel";
import { siteTitle } from "./data/commerce";
export function App() {
  useMetaPixel();
  useEffect(() => {
    document.title = siteTitle;
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3fbj8evsndfrq">
      <Landing data-id="element-1" data-mp="3f8nd7f86p56z" />
    </MotionConfig>;
}